export default {
  list: [
    {
      type: 'Divider'
    },
    {
      type: 'Tank',
      title: '',
      extra: {
        serial: '',
        name_for_meter: '',
        name_for_percent: ''
      }
    },
    {
      type: 'Pump',
      title: '',
      extra: {
        serial: '',
        name: '',
        mode: 'complex'
      }
    },
    {
      type: 'PumpStatus',
      title: '',
      extra: {
        serial: ''
      }
    },
    {
      type: 'Alarms',
      title: '',
      extra: {
        devices: []
      }
    },
    {
      type: 'Information',
      title: '',
      extra: [
        {
          inverted: true,
          name: '',
          note: '',
          serial: ''
        }
      ]
    },
    {
      type: 'DataIcons',
      title: '',
      extra: [
        {
          icon: 'motor',
          name: '',
          serial: '',
          title: ''
        }
      ]
    },
    {
      type: 'Stage1',
      title: '',
      extra: {
        serial: '',
        name: ''
      }
    },
    {
      type: 'LineChart'
    },
    {
      type: 'OverflowPump',
      title: '',
      extra: {
        serial: '',
        name: ''
      }
    },
    {
      type: 'OverflowTank',
      title: '',
      extra: {
        serial: '',
        name_upper: '',
        name_lower: ''
      }
    },
    {
      type: 'SimpleData',
      title: '',
      extra: {
        serial: '',
        name: '',
        unit: ''
      }
    },
    {
      type: 'ResetButton',
      title: '',
      extra: {
        action: 'pulse',
        parameters: {
          duration: 3000,
          name: '',
          serial: '',
          value: 1,
          value_after: 0
        }
      }
    },
    {
      type: 'Level',
      title: '',
      extra: {}
    },
    {
      type: 'Config',
      title: '',
      extra: {
        serial: '',
        parameters: [
          {
            name: '',
            title: '',
            unit: ''
          }
        ]
      }
    },
    {
      type: 'ActionButton',
      title: '',
      extra: {}
    },
    {
      type: 'RunMode',
      title: '',
      extra: {}
    },
    {
      type: 'BooleanIndicator',
      title: '',
      extra: {}
    },
    {
      type: 'PeriodReport',
      title: '',
      extra: {
        serial: '',
        singleDate: false,
        modes: [
          {
            type: 'day',
            name: 'Päev'
          },
          {
            type: 'hour',
            name: 'Tund'
          }
        ]
      }
    },
    {
      type: 'DataChart',
      title: '',
      extra: {
        serial: '',
        height: '250'
      }
    },
    {
      type: 'LinkButton',
      title: '',
      extra: {
        url: ''
      }
    },
    {
      type: 'ChartModal',
      title: '',
      extra: {
        serial: '',
        parameters: [],
        advanced: true,
        id: 1
      }
    },
    {
      type: 'ControlButton',
      title: '',
      extra: {
        serial: '',
        options: [
          { title: '', value: 0 }
        ]
      }
    },
    {
      type: 'OverviewMap',
      title: '',
      extra: {
        height: 300
      }
    }
  ]

}
